<template>
    <div class="content">
        <top-menu></top-menu>
        <div id="main-content" class="main-content">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
        <main-footer></main-footer>
    </div>
</template>
<script>
    export default {
        name: '',
        data () {
            return {
            }
        },
        components: {
            'top-menu': require('@/components/layout/top-menu.vue'),
            'main-footer': require('@/components/layout/footer.vue')
        },
        methods: {
        }
    }
</script>
<style lang="scss" scoped>
    @import url('../../styles/index.scss');
</style>



// WEBPACK FOOTER //
// layout.vue?eb0f1aaa